import React, { memo } from "react";

import ReactTable from "react-table";
import NameEdit from "./NameEdit";

const HelperAssignments = ({ helpersArray, i18n, closeModal }) => {
  return (
    <div id="helperAssignmentsContainer">
      <ReactTable
        showPagination={false}
        data={helpersArray}
        columns={[
          {
            Header: "id",
            accessor: "helper.id",
            show: false
          },
          {
            Header: i18n.getResourcesByKey("driver.key"),
            accessor: "helper.key"
          },
          {
            Header: i18n.getResourcesByKey("driver.name"),
            accessor: "helper.name",
            Cell: props =>
              <NameEdit
                value={props.value}
                row={props.row}
                closeModal={closeModal}
              />
          },
          {
            Header: i18n.getResourcesByKey("driver.login"),
            accessor: "helper.login"
          },
          {
            Header: i18n.getResourcesByKey("driver.phone1"),
            accessor: "helper.phone1"
          },
          {
            Header: i18n.getResourcesByKey("driver.phone2"),
            accessor: "helper.phone2"
          }
        ]}
        defaultPageSize={helpersArray.length}
        className="-highlight"
      />
    </div>
  );
};

export default memo(HelperAssignments);
